import $ from "jquery";
import Field from "./../field";

const Dropdown = (($) => {
  class Dropdown extends Field {
    getValue() {
      let value = null;
      let index = this._input.selectedIndex;
      if (index) {
        value = this._input.options[index].value;
      }
      return value;
    }

    render() {
      const self = this;

      let id = this.getForm().getID() + "_field_" + this._field.formFieldID;

      this._element = document.createElement("div");
      this._element.classList.add("ion-form-group");
      this._element.classList.add("ion-form-group-dropdown");

      // Label
      this._label = document.createElement("label");
      this._label.htmlFor = id;
      this._label.innerText = this._field.label;
      this._element.appendChild(this._label);

      // Input
      this._input = document.createElement("select");
      this._input.id = id;
      this._input.classList.add("ion-form-control");
      this._input.name = this._field.slug;
      this._input.ariaLabel = this._field.label;
      this._element.appendChild(this._input);

      let isRequired = this.getSetting("isRequired", false);
      if (isRequired == "1") {
        this._element.classList.add("ion-is-required");
        this._input.ariaRequired = true;
      }

      // Default Value
      let defaultValue = this.getSetting("defaultValue");

      // Placeholder
      let placeholder = this.getSetting("placeholder", "Select One...");
      let placeholderOption = document.createElement("option");
      placeholderOption.value = "";
      placeholderOption.innerText = placeholder;
      this._input.appendChild(placeholderOption);

      // Options
      let optionString = this.getSetting("options", "");
      let options = optionString.split("\r\n");
      options.forEach(function (optionString) {
        if (optionString && optionString.length > 0) {
          let option = document.createElement("option");
          option.value = optionString;
          option.innerText = optionString;
          if (defaultValue == optionString) {
            option.selected = "selected";
          }
          self._input.appendChild(option);
        }
      });

      // Instructions
      let instructions = this._renderInstructions();
      if (instructions) {
        this._element.appendChild(instructions);
      }

      // Messages
      this._renderMessages();
      if (this._messages) {
        this._element.appendChild(this._messages);
      }
    }
  }

  return Dropdown;
})($);

export default Dropdown;
